<template>
  <div v-loading="loading">
    <el-row :gutter="10">
      <el-form :model="user" :rules="rules" ref="VerifyUserForm" size="mini">
        <el-col :md="8">
          <el-form-item prop="dni" :label="identity.name">
            <el-input v-model="user.dni" :placeholder="identity.example" />
          </el-form-item>
          <el-form-item prop="email" label="Correo">
            <el-input v-model="user.email" placeholder="correo@mail.com" />
          </el-form-item>
          <el-form-item prop="name" label="Nombre">
            <el-input v-model="user.name" placeholder="Ian" />
          </el-form-item>
          <el-form-item prop="lastName" label="Apellido">
            <el-input v-model="user.lastName" placeholder="Ian" />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item v-if="accountTypeId === 5" prop="enterpriseId" label="Empresa">
            <el-select
              v-model="user.enterpriseId"
              filterable
              clearable
              placeholder="Seleccione una opción"
              no-data-text="Cargando...">
              <el-option v-for="enterprise in enterprises" :key="enterprise.id"
                :label="enterprise.name"
                :value="enterprise.id" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="accountTypeId === 7" prop="enterpriseIds" label="Empresas">
            <el-select
              v-model="user.enterpriseIds"
              multiple
              filterable
              clearable
              placeholder="Seleccione una o más opciones"
              no-data-text="Cargando...">
              <el-option v-for="enterprise in enterprises" :key="enterprise.id"
                :label="enterprise.name"
                :value="enterprise.id" />
            </el-select>
          </el-form-item>
          <el-form-item v-else-if="accountTypeId === 8" prop="enterpriseId" label="Empresa">
            <el-select
              v-model="user.enterpriseId"
              filterable
              clearable
              placeholder="Seleccione una opción"
              no-data-text="Cargando...">
              <el-option v-for="enterprise in enterprises" :key="enterprise.id"
                :label="enterprise.name"
                :value="enterprise.id" />
            </el-select>
          </el-form-item>
          <el-form-item prop="newPassword" label="Contraseña">
            <el-input v-model="user.newPassword" autocomplete="off" type="password"
              placeholder="******" required />
          </el-form-item>
          <el-form-item prop="newPasswordConfirm" label="Verificar contraseña">
            <el-input v-model="user.newPasswordConfirm" autocomplete="off" type="password"
              placeholder="******" />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item>
            <el-button class="default" @click="verify">CREAR</el-button>
            <el-button class="flat" @click="cancel">CANCELAR</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import { cachedAPIRequest } from '@/mixins/cacheDim';

export default {
  name: 'UserFormStep2',
  props: {
    accountTypeId: {
      type: Number,
      default: 0,
    },
    identity: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const enterpriseIdsCheck = (rule, value, callback) => {
      if (this.accountTypeId !== 7) {
        callback();
      } else if (!Array.isArray(value) || value.length === 0) {
        callback(new Error('Seleccione al menos una empresa'));
      } else {
        callback();
      }
    };
    const passValidation = (rule, value, callback) => {
      if (!this.validPassword(value)) {
        callback(new Error('la contraseña debe contener al menos 1 minúscula, mayúscula, número y símbolo especial con una longitud mínima de 10'));
      } else if (!this.validOccurance(value)) {
        callback(new Error('password is weak because its contains series like 123'));
      } else {
        callback();
      }
    };
    const passCheck = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('Complete el campo'));
      } else if (value !== this.user.newPassword) {
        callback(new Error('Contraseñas no coinciden'));
      } else {
        callback();
      }
    };
    const emailCheck = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('Complete el campo'));
      } else if (!this.validEmail(value)) {
        callback(new Error('Formato incorrecto'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      user: {
        dni: '',
        name: '',
        lastName: '',
        email: '',
        newPassword: '',
        newPasswordConfirm: '',
        enterpriseId: '',
        enterpriseIds: [],
        accountTypeId: '',
      },
      rules: {
        dni: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }],
        email: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        },
        { validator: emailCheck, trigger: 'blur' }],
        name: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }],
        lastName: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }],
        newPassword: [{ validator: passValidation },
          {
            required: true,
            trigger: 'change',
            message: 'Complete el campo',
          }],
        newPasswordConfirm: [{ validator: passCheck, trigger: 'blur' }],
        enterpriseId: [{
          required: true,
          trigger: 'change',
          message: 'Complete el campo',
        }],
        enterpriseIds: [{ validator: enterpriseIdsCheck, trigger: 'change' }],
      },
      enterprises: [],
    };
  },
  mounted() {
    this.getEnterprises();
  },
  methods: {
    verify() {
      this.$refs.VerifyUserForm.validate((valid) => {
        if (valid) { this.$emit('send', this.getData()); }
        return valid;
      });
    },
    getData() { // todo: necesita refactor
      const baseData = {
        account_types_id: this.accountTypeId,
        active: true,
        email: this.user.email.toLowerCase(),
        last_name: this.user.lastName,
        name: this.user.name,
        password: this.user.newPassword,
        rut: this.user.dni,
        username: this.user.email.toLowerCase(),
      };

      if (this.accountTypeId === 5) {
        return {
          ...baseData,
          enterprise_id: this.user.enterpriseId,
        };
      }

      if (this.accountTypeId === 7) {
        return {
          ...baseData,
          account_types_id: 7,
          enterprise_ids: this.user.enterpriseIds.map(id => Number(id)),
        };
      }

      if (this.accountTypeId === 8) {
        return {
          ...baseData,
          account_types_id: 8,
          enterprise_ids: [Number(this.user.enterpriseId)],
        };
      }

      return baseData;
    },
    cancel() {
      this.loading = true;
      this.$emit('cancel');
    },
    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPassword(val) {
      const passw = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9\s]).{10,16}$/;
      return passw.test(val);
    },
    validOccurance(val) {
      const aToz = '0123456789';
      let s = '';
      for (let i = 0; i < val.length; i += 1) { // Mohan@1234
        for (let j = i; j < val.length; j += 1) {
          s += val.charAt(j);
          if (s.length > 2) {
            if (aToz.includes(s)) {
              return false;
            }
          }
        }
        s = '';
      }
      return true;
    },
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((response) => {
        this.enterprises = response.data;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
